import React, {Component} from 'react';

class UserAttributesCell extends Component {

  handleValueChange = (e) => {
    this.props.onUserAttributesTableUpdate(e);
  }
  handleOnBlur = (e) => {
    e.target.value = e.target.value.trim();
    this.props.onUserAttributesTableUpdate(e);
  }

  render() {
    return (
        <input className={this.props.className}
               type='text'
               name={this.props.cellData.type}
               value={this.props.cellData.value}
               id={this.props.cellData.id}
               placeholder={this.props.cellData.placeholder}
               onChange={this.handleValueChange}
               onBlur={this.handleOnBlur}/>
    );
  }
}

export default UserAttributesCell;
